import React from 'react';
import { Target, Award, Users } from 'lucide-react';
import { aboutContent, companyInfo } from '../data/mock';

export const About = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">À Propos de Nous</h1>
          <p className="page-hero-description">
            Découvrez l'histoire et les valeurs qui font de nous votre partenaire de confiance
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="section-padding">
        <div className="container">
          <div className="about-grid">
            <div className="about-image-section">
              <img 
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="about-logo"
              />
            </div>
            <div className="about-content-section">
              <h2 className="about-title">{aboutContent.title}</h2>
              <p className="about-text">
                {aboutContent.description}
              </p>
              <p className="about-text">
                Basés dans l'Hérault, nous intervenons sur l'ensemble du département et ses alentours 
                pour offrir des services d'entretien et d'aménagement d'espaces verts de qualité. 
                Notre équipe passionnée met son savoir-faire au service de vos projets, qu'il s'agisse 
                de l'entretien régulier de votre jardin ou de la création d'un nouvel aménagement paysager.
              </p>
              <p className="about-text">
                Nous nous engageons à respecter l'environnement dans toutes nos interventions, 
                en privilégiant des méthodes durables et respectueuses de la nature.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos Valeurs</h2>
            <p className="section-subtitle">
              Ce qui guide notre travail au quotidien
            </p>
          </div>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon-wrapper">
                <Award className="value-icon" />
              </div>
              <h3 className="value-title">{aboutContent.values[0].title}</h3>
              <p className="value-description">{aboutContent.values[0].description}</p>
            </div>

            <div className="value-card">
              <div className="value-icon-wrapper">
                <Target className="value-icon" />
              </div>
              <h3 className="value-title">{aboutContent.values[1].title}</h3>
              <p className="value-description">{aboutContent.values[1].description}</p>
            </div>

            <div className="value-card">
              <div className="value-icon-wrapper">
                <Users className="value-icon" />
              </div>
              <h3 className="value-title">{aboutContent.values[2].title}</h3>
              <p className="value-description">{aboutContent.values[2].description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">100+</div>
              <div className="stat-label">Clients Satisfaits</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5+</div>
              <div className="stat-label">Années d'Expérience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Projets Réalisés</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">34</div>
              <div className="stat-label">Zone d'Intervention</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
